import React from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { WhyFailSection } from './components/WhyFailSection';
import { ProtocolSection } from './components/ProtocolSection';
import { AboutKate } from './components/AboutKate';
import { ServicesMenu } from './components/ServicesMenu';
import { FeaturedTreatments } from './components/FeaturedTreatments';
import { GuaranteeSection } from './components/GuaranteeSection';
import { HoursLocation } from './components/HoursLocation';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { WhatsAppFloat } from './components/WhatsAppFloat';
import { PromoBanner } from './components/PromoBanner';
import { LanguageProvider } from './context/LanguageContext';
import { SEOHead } from './components/SEOHead';
import { IntroCurtain } from './components/IntroCurtain';
export function App() {
  return <LanguageProvider data-id="element-0">
      <SEOHead data-id="element-1" />
      <IntroCurtain data-id="element-2" />
      <div className="min-h-screen bg-brand-white font-sans text-brand-charcoal selection:bg-brand-gold/30" data-id="element-3">
        <PromoBanner data-id="element-4" />
        <Header data-id="element-5" />
        <main data-id="element-6">
          <HeroSection data-id="element-7" />
          <PainSection data-id="element-8" />
          <TestimonialsSection data-id="element-9" />
          <WhyFailSection data-id="element-10" />
          <ProtocolSection data-id="element-11" />
          <AboutKate data-id="element-12" />
          <FeaturedTreatments data-id="element-13" />
          <ServicesMenu data-id="element-14" />
          <GuaranteeSection data-id="element-15" />
          <HoursLocation data-id="element-16" />
          <FAQSection data-id="element-17" />
          <FinalCTA data-id="element-18" />
        </main>
        <Footer data-id="element-19" />
        <WhatsAppFloat data-id="element-20" />
      </div>
    </LanguageProvider>;
}